export function getDayMonthYear(date, displayYearOnlyIfRequired = true) {
  let string = `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}`;
  if (!displayYearOnlyIfRequired || new Date().getYear() != date.getYear()) {
    string += `/${String(date.getYear() - 100)}`;
  }
  return string;
}

export const getDateString = (date, shortYear = true) => {
  const date_ = ("0" + date.getDate()).slice(-2);
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const year = shortYear ? date.getYear().toString().substr(1, 2) : date.getFullYear();
  return date_ + "/" + month + "/" + year;
};
export const getTimeString = (date, minutesOnly = false) => {
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");
  return hours + ":" + minutes + (minutesOnly ? "" : ":" + seconds);
};

export const getDateTimeString = (date, minutesOnly = false) => {
  return getDateString(date) + " " + getTimeString(date, minutesOnly);
};

export function getRelativeTimeString(date1_, date2 = new Date()) {
  const date1 = new Date(date1_);
  const units = {
    year: 24 * 60 * 60 * 1000 * 365,
    month: (24 * 60 * 60 * 1000 * 365) / 12,
    week: 24 * 60 * 60 * 1000 * 7,
    day: 24 * 60 * 60 * 1000,
    hour: 60 * 60 * 1000,
    minute: 60 * 1000,
    second: 1000,
  };

  const rtf = new Intl.RelativeTimeFormat("he", {
    numeric: "auto",
  });

  const passed = date2 - date1;
  if (passed <= units.minute) return "כעת";
  if (passed > units.day) {
    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);
  }

  const elapsed = date1 - date2;

  // "Math.abs" accounts for both "past" & "future" scenarios
  for (var u in units) if (Math.abs(elapsed) >= units[u] || u == "second") return rtf.format(Math.round(elapsed / units[u]), u);
}

export function getDateRange(startTimestamp, endTimestamp) {
  const dates = [];
  let currentDate = new Date(startTimestamp);

  // Ensure we loop until the end date
  while (currentDate <= endTimestamp) {
    dates.push(new Date(currentDate)); // Add a copy of the date to the array

    // Move to the next day
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
}
